
export default function SQLs_Create_Table() {
  return (
    <div>
      <h1>SQL Create Table</h1>
      <p>Content for SQL Create Table will go here.</p>
    </div>
  );
}
